// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const isWithinMaxDecimals = (v, max) => (
  !v.split('.')[1] || v.split('.')[1].length <= max
)

export default isWithinMaxDecimals
